import { formatearMonedaCliente } from "src/utils/formatearMonedaCliente";

export const formatValorItem = (tipoMoneda, valor) => {
  if (
    valor === null ||
    valor === undefined ||
    valor === "" ||
    Number.isNaN(Number(valor))
  ) {
    return "—";
  }
  const n = Number(valor);
  const moneda = formatearMonedaCliente(tipoMoneda);

  if (moneda === "CLP") {
    return `$${n.toLocaleString("es-CL")} CLP`;
  }

  if (moneda === "USD") {
    return `$${n.toLocaleString("es-CL", { maximumFractionDigits: 2 })} USD`;
  }
  if (moneda === "EUR") {
    return `${n.toLocaleString("es-CL", { maximumFractionDigits: 2 })} EUR`;
  }
  if (moneda === "UF") {
    return `${n.toLocaleString("es-CL", { maximumFractionDigits: 2 })} UF`;
  }
  if (moneda === "UTM") {
    return `${n.toLocaleString("es-CL", { maximumFractionDigits: 2 })} UTM`;
  }
  return `${n.toLocaleString("es-CL")} ${moneda}`.trim();
};
